class FAQAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.details = this.querySelectorAll('details.faq__item');
    this.details.forEach(detail => {
      this.setupDetail(detail);
    });
    this.observeChanges();
  }

  setupDetail(detail) {
    const question = detail.querySelector('.faq__question');
    const answer = detail.querySelector('.faq__answer');

    if (!question || !answer) return;

    question.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle(detail, answer);
    });
  }

  toggle(detail, answer) {
    const isOpen = detail.hasAttribute('open');

    if (isOpen) {
      this.close(detail, answer);
    } else {
      this.open(detail, answer);
    }
  }

  open(detail, answer) {
    detail.setAttribute('open', '');
    
    requestAnimationFrame(() => {
      this.setHeight(answer, answer.scrollHeight);
      answer.style.opacity = '1';
    });
  }

  close(detail, answer) {
    answer.style.opacity = '0';
    
    this.setHeight(answer, 0);
    
    setTimeout(() => {
      detail.removeAttribute('open');
    }, 200);
  }

  setHeight(answer, height) {
    answer.style.maxHeight = height === 0 ? '0px' : `${height}px`;
  }

  observeChanges() {
    const observer = new ResizeObserver(() => {
      this.details.forEach(detail => {
        if (detail.hasAttribute('open')) {
          const answer = detail.querySelector('.faq__answer');
          if (answer) {
            this.setHeight(answer, answer.scrollHeight);
          }
        }
      });
    });

    // Observe the container for size changes (handles window resize and text wrapping)
    observer.observe(this);

    this.details.forEach(detail => {
      const answer = detail.querySelector('.faq__answer');
      if (answer) {
        observer.observe(answer);
      }
    });
  }
}

customElements.define('faq-accordion', FAQAccordion);
